import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    // Ensure gtag exists (loaded in index.html)
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    const pagePath = (location.pathname || '/') + (location.search || '');

    // Send page_path with both GA4 and Ads config so SPA navigation is recorded as page views
    try {
      window.gtag('config', 'G-Q6Y8JG5EM7', { page_path: pagePath });
      window.gtag('config', 'AW-17615346292', { page_path: pagePath });
    } catch (e) {
      // silent fail; analytics should not break the app
      // console.debug('gtag config failed', e);
    }
  }, [location]);

  return null;
}
